import type { User } from "@/types";

const FRONTOFFICE_ROLES = [
  "ROLE_ADMIN",
  "ROLE_CARRIER",
  "ROLE_CPINTERVENANT",
  "ROLE_SUBCONTRACTOR",
];

export const hasRole = (
  user: Pick<User, "roles"> | null | undefined,
  role: string,
) => Array.isArray(user?.roles) && user.roles.includes(role);

export const isPureFunder = (user: Pick<User, "roles"> | null | undefined) => {
  if (!hasRole(user, "ROLE_FUNDER")) {
    return false;
  }

  return !FRONTOFFICE_ROLES.some((role) => hasRole(user, role));
};

export const canAccessFrontoffice = (
  user: Pick<User, "roles"> | null | undefined,
) => !isPureFunder(user);
